import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "9093c15f-2669-4295-9c4f-6291df0c56e3",
      type: "Sprite",
      name: "glow",
      nameSpace: "",
      className: "",
      x: 150,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_meter_glow",
      parent: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      data: ""
    },
    {
      id: "29aabb9e-5eca-476f-a38b-4b0e1a379496",
      type: "Sprite",
      name: "bg",
      nameSpace: "",
      className: "",
      x: 0,
      y: -16,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "combo_board",
      parent: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      data: ""
    },
    {
      id: "d60cb554-df73-4d61-90ac-521f896fa534",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 107,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "StreakBarTitle",
      localize: true,
      maxWidth: 172,
      maxHeight: 37,
      maxFontSize: 22,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#892e2e",
        stroke: "black",
        strokeThickness: 0,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      data: ""
    },
    {
      id: "ce24140d-295c-48a5-a78d-84a1f10ef2d5",
      type: "Sprite",
      name: "progressStroke",
      nameSpace: "",
      className: "",
      x: 17,
      y: 28,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_board_fill",
      parent: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      data: ""
    },
    {
      id: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      type: "Container",
      name: "pipsContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      data: ""
    },
    {
      id: "0567f857-03ad-4ef9-a80b-cdf6e9819633",
      type: "Sprite",
      name: "rewardBg",
      nameSpace: "",
      className: "",
      x: 240,
      y: 36,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_reward_wood",
      parent: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      data: ""
    },
    {
      id: "cb55dd9d-9725-40d0-9555-ac9f3553a8e3",
      type: "Container",
      name: "goldAnimationContainer",
      nameSpace: "",
      className: "",
      x: 240,
      y: 36,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      data: ""
    },
    {
      id: "0b4acbdc-05be-48b1-a78b-b4d951a5c6ce",
      type: "Sprite",
      name: "reward",
      nameSpace: "",
      className: "",
      x: 242,
      y: 42,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_reward_card_1",
      parent: "dfbe7f13-78f9-47e3-bbef-5eb85682d135",
      data: ""
    },
    {
      id: "53861293-0bf3-4095-a9e8-c1601459123e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 43,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_empty",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "d3501810-46db-4e23-8047-764b67938525",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 74,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_empty",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "a58ec1e2-1032-4402-9a99-7e3a5a65fd83",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 106,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_empty",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "6c964bd9-f75e-417d-849a-85ad7f2a0c5c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 137,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_empty",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "1f0eb2c7-7b43-4d55-97ec-5c297937194c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 167,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_empty",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "fd8a826b-a1f4-4516-82a9-e8b356db38bf",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "pips",
      x: 43,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_red",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "22ea9f3e-a663-4241-a2ff-5fb8fd428945",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "pips",
      x: 74,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_red",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "9716b04c-c4f4-4519-a011-216eaff5863c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "pips",
      x: 106,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_red",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "37fc1334-0875-4ba7-a6ed-5a61684bde5c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "pips",
      x: 137,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_red",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    },
    {
      id: "1000891b-b7cc-496b-b24f-3c64111a789e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "pips",
      x: 167,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_red",
      parent: "718381aa-90e4-47aa-82f1-e0fdba113b43",
      data: ""
    }
  ]
} as const;

export class StreakBarLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  glow: GameObject<PIXI.Sprite>;
  bg: GameObject<PIXI.Sprite>;
  progressStroke: GameObject<PIXI.Sprite>;
  pipsContainer: GameObject<PIXI.Container>;
  rewardBg: GameObject<PIXI.Sprite>;
  goldAnimationContainer: GameObject<PIXI.Container>;
  reward: GameObject<PIXI.Sprite>;
  pips: (GameObject<PIXI.Sprite>)[];

  constructor() {
    populate(this, raw);
  }
}
